// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import './plugin/mint.js'
import './plugin/amap.js'
import './plugin/echart.js'
import './assets/icon/iconfont.css'
import App from './App'
import router from './router'
import echarts from 'echarts'
import store from  './store'
Vue.config.productionTip = false
Vue.prototype.$echarts = echarts
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js